import LineTool from './LineTool';

/** Gann Fan tool */
class GannFanLineTool extends LineTool {
	constructor(core, settings) {
		super(core, settings);

		this.thresholds = this.params.style.thresholds;
		this.gannLabelsUpper = this.params.style.gannLabels;
		this.gannLabelsLower = this.gannLabelsUpper.map(label => label.split('/').reverse().join('/'));
	}

	_getDefaultParams() {
		return {
			id: 'gannFan',
			name: 'Gann Fan',
			style: this.core.getStyle('tool.gannFan')
		};
	}

	render() {
		const coords = [this.handle[0].getCoords(), this.handle[1].getCoords()];

		if (!coords[0] || !coords[1]) return;

		const ctx = this.panel.rootToolContext;
		let i;
		let newX;
		let newY;
		const x1 = coords[0][0];
		const y1 = coords[0][1];
		const x2 = coords[1][0];
		let y2 = coords[1][1];
		const distX = x2 - x1;
		const distY = y2 - y1;
		const { style } = this.params;
		const { color, thresholds } = style;

		ctx.lineWidth = style.width;
		ctx.font = `${this.params.style.label.font.weight} ${this.params.style.label.font.size}px ${this.params.style.label.font.family}`;

		// Middle line
		this.renderFan(
			ctx,
			color[0],
			this.gannLabelsUpper[0],
			x1,
			y1,
			x2,
			y2,
			x2 - x1,
			y2 - y1
		);

		// Lower lines
		ctx.textAlign = 'left';
		for (i = 1; i < thresholds.length; i++) {
			newY = y2 - (distY - distY * thresholds[i]);

			this.renderFan(
				ctx,
				color[i],
				this.gannLabelsLower[i],
				x1,
				y1,
				x2,
				newY,
				x2 - x1,
				newY - y1
			);
		}

		// Upper lines
		y2 = coords[1][1];
		ctx.textAlign = 'right';
		for (i = 1; i < thresholds.length; i++) {
			newX = x2 - (distX - distX * thresholds[i]);

			this.renderFan(
				ctx,
				color[i],
				this.gannLabelsUpper[i],
				x1,
				y1,
				newX,
				y2,
				newX - x1,
				y2 - y1
			);
		}

		this.handle[0].render();
		this.handle[1].render();

		this.panel.core.onToolRender(this);
	}

	renderFan(ctx, color, label, x1, y1, x2, y2, distX, distY) {
		ctx.beginPath();
		ctx.strokeStyle = color;
		ctx.fillStyle = color;
		ctx.moveTo(x1, y1);
		ctx.lineTo(x2, y2);
		ctx.stroke();

		this._renderRay(ctx, x2, y2, distX, distY);
		ctx.stroke();

		// Use specific label color if defined, otherwise use the section color
		ctx.fillStyle = this.params.style.label.color || color;
		ctx.fillText(label, x2, y2);
	}
}

export default GannFanLineTool;
